import { Download, Menu, RotateCcw, ZoomIn, ZoomOut, Printer, Share2 } from 'lucide-react';

function Resume() {
  return (
    <div className="resume">
      <h1 className="resume-title">CV</h1>
      <p className="resume-subtitle">Téléchargez une copie ou consultez ci-dessous.</p>
      
      <a href="/nefertiti-dadjo-cv.pdf" download className="btn-primary">
        <Download size={18} />
        <span>Télécharger PDF</span>
      </a>

      <div className='mt-12'>
        <iframe src="/nefertiti-dadjo-cv.pdf" width="100%" height="600px" title="CV Néfertiti DADJO"></iframe>
      </div>
    </div>
  );
}

export default Resume;
